import styled from 'styled-components';
export const TablePaginationStyled = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
export const OnRowsPerPageChangeContainerStyled = styled.div `
  display: flex;
  flex-direction: row;
  gap: 16px;
`;
export const PaginationContainerStyled = styled.div `
  gap: 17px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const PaginationEnumerationContainerStyled = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;
export const PaginationEnumerationStyled = styled.div `
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 7px;
  border-radius: 8px;
  border: 1px solid #cfd0d8;
  background: #fff;
  position: relative;
`;
export const DropdownItemWrapperStyled = styled.div `
  position: absolute;
  z-index: 10;
  ${({ expandDirection }) => (expandDirection === 'top' ? 'bottom: 42px;' : 'top: 42px;')}
  left: 0px;
  transform-origin: top;
  ${({ open }) => open ? 'transform: scaleY(1);  max-height: 186px;' : 'transform: scaleY(0);  max-height: 0px;'}
  transition-duration: 0.5s;
  button:nth-last-child(-n + 1) {
    border-radius: 0px 0px 4px 4px;
  }
  display: flex;
  justify-content: center;
`;
export const DropdownItemContainerStyled = styled.div `
  display: flex;
  flex-direction: column;
  width: auto;
  padding: 11.5px 0px 17.5px 0px;
  border-radius: 8px;
  gap: 8px;
  background: ${({ theme }) => theme.colors.gray100}};
  box-shadow: 4px 4px 20px 0px rgba(111, 140, 176, 0.41), -6px -6px 20px 0px #FFF, 2px 2px 4px 0px rgba(114, 142, 171, 0.10);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 3px; /* Set the width of the scrollbar */
  }
  &::-webkit-scrollbar-thumb {
    background: #D9D9D9;; /* Color of the scrollbar thumb */
    border-radius: 50px; /* Rounded corners of the scrollbar thumb */
  }

`;
export const DropdownItemStyled = styled.div `
  ${({ selected }) => `padding 4px ${selected ? '15px' : '16px'};`}
  ${({ selected, theme }) => selected &&
    `
      color: ${theme.colors.gray100};
      background-color: ${theme.colors.blue500};
  `}
`;
//# sourceMappingURL=styled.js.map